<template>
  <div :class="['promote-main',(!list || list.length==0)?'on':'']" v-if="body_show">
    <div class="promote-search">
      <input @focus="bool=false" @blur="bool=true && !nickname" v-model="nickname" @keyup.enter="searchHandle()" type="text" />
      <div v-show="bool" class="ph">
        <img src="@a/lower-search.png" alt />
        <span>查询好友</span>
      </div>
    </div>
    <!-- list -->
    <div class="lower-list">
      <!-- header -->
      <div class="lower-header">
        <div class="flex-item left">我的下级</div>
        <div class="flex-item">我的返佣（元）</div>
      </div>
      <!--content list  -->
      <div class="no-lower" v-if="!list || list.length==0" >
        <img src="@a/lower-bg.png" alt="">
        <a class="btn" @click="$router.push({
                    path:'/training_money',
                    query:{
                        course_id:$route.query.course_id,
                        type: 100
                    }
                })">
          发展下级
        </a>
      </div>
      <div  v-else v-for="(item,index) in list" :key="index" class="lower-content">
        <img :src="item.headimgurl" alt="">
        <h4>{{item.nickname}}</h4>
        <span>{{item.commission}}</span>
      </div>
    </div>
    <!-- 引入意见反馈 -->
    <public-feedback></public-feedback>
  </div>
</template>

<script>
import { myDownline } from "@/api/training";
import { shareCon } from "@/utils/wxconfig";
import publicFeedback from "@c/training/public-feedback"
export default {
  data() {
    return {
      body_show: false,
      nickname: "",
      list: [],
      pager:{},
      size: 15,
      bool:true,
      //是否加载数据
      upLoading: true,
      searchName:''
    };
  },
  components:{
    publicFeedback
  },
  methods: {
      /*
       *@param:
       *@return:
       *@Description: 搜索
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-09-25 18:13:09
      */
      searchHandle(){
          this.pager['page'] = 0;
          this.pullData(true);
      },
    /*
     *@param:
     *@return:
     *@Description:页面初始化请求方法
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-09-25 11:27:29
     */
    pullData(bool) {
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });

      let obj = {
        page: (this.pager && Object.keys(this.pager).length>0)?(this.pager.page += 1):1,
        size: this.size
      };
      if (this.nickname) {
        //搜索昵称（可选）
        obj["nickname"] = this.nickname;
      }
      myDownline(obj).then(data => {
        this.pager =data.pager;
        if((this.nickname && (this.searchName !== this.nickname))||bool){
            this.list.splice(0,this.list.length);
            this.searchName = this.nickname;
        }
        this.list=[...this.list,...data.list];
        this.body_show = true;
        this.$toast.clear();
      });
    }
  },
  created() {
    this.pullData();
  },
  mounted(){
       //滚动监听
    window.onscroll = ()=>{
        let that = this;
        let marginBot = 0;
        if (document.documentElement.scrollTop){
            let X=document.documentElement.scrollHeight;
            let Y=document.documentElement.scrollTop+document.body.scrollTop;
            let Z=document.documentElement.clientHeight;
            marginBot=X-Y-Z;
        } else {
            let J=document.body.scrollHeight;
            let I=document.body.scrollTop;
            let K=document.body.clientHeight;
            marginBot=J-I-K;
        }

        if(marginBot<=0 && (this.pager &&(this.list.length< this.pager.count))) {
            that.pullData();
        }
    }
  }
};
</script>

<style lang="scss">
.promote-main {
  .promote-search {
    position: relative;
    width: 100%;
    line-height: 70px;
    margin: 20px auto;
    background-color: #fff;
    z-index: 1;
    input {
      font-size: 26px;
      color: #333;
      height: 70px;
      width: 100%;
      border: 0;
      text-align: center;
      background-color: transparent;
      z-index: 3;
    }
    .ph {
      z-index: -1;
      display: flex;
      align-items: center;
      position: absolute;
      height: 100%;
      font-size: 26px;
      color: #999999;
      top: 0;
      left: 300px;
      img {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
      span {
        margin-left: 8px;
      }
    }
  }
  .lower-list {
    .lower-header {
      height: 90px;
      padding: 20px 0;
      background-color: #eb5032;
      color: #ffffff;
      font-size: 32px;
      display: flex;
      .flex-item {
        flex: 1;
        text-align: center;
      }
      .flex-item.left {
        border-right: 1px solid #ffffff;
      }
    }
    .lower-content{
        display: flex;
        align-items: center;
        line-height: 100px;
        background-color: #ffffff;
        border-bottom: 2px solid #E1E1E1;
        img{
            border: 0;
            border-radius: 50%;
            width:64px;
            height: 64px;
            line-height: 64px;
            margin-left: 85px;
        }
        h4{
            font-size: 26px;
            color: #333333;
            margin-left: 10px;
            margin-right: auto;
        }
        span{
            font-size: 26px;
            color: #333333;
            margin-right: 156px;
        }
    }
    .lower-content:last-child{
        border: 0;
    }
  }
}
.promote-main.on{
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .lower-list {
    display: flex;
    flex-direction: column;
    flex: 1;
    .no-lower{
      flex: 1;
      text-align: center;
      background-color: #ffffff;
      img{
        width:574px;
        height: 366px;
        margin: 218px auto 50px;
      }
      .btn{
        display: block;
        font-size: 26px;
        background-color: #EB5032;
        color: #ffffff;
        border-radius:27px;
        line-height: 54px;
        text-align: center;
        width: 150px;
        margin: 0 auto;
      }
    }
  }
}
</style>